<template>
  <div id="screen-saver" :class="{ hide: hideScreenSaver }" @click="closeScreenSaver()">
    <!-- <video poster="/static/laika-splash-1-poster.jpg" id="bgvid" playsinline autoplay mute loop> -->
    <div id="spinner" class="flex items-center z0">
      <div class="lds-ring mx-auto"><div></div><div></div><div></div><div></div></div>
    </div>
    <video id="bgvid" muted playsinline v-if="!paused && !hideScreenSaver" ref="ssvid" class="z1">
      <source :src="splashVideo" type="video/mp4">
    </video>
    <div id="screen-saver-text" class="flex flex-column justify-center" v-if="showText">
      <div class="flex pt3"><div>L</div></div>
      <div class="flex items-center"><div>A</div></div>
      <div class="flex items-center"><div>I</div></div>
      <div class="flex items-center"><div>K</div></div>
      <div class="flex items-center"><div>A</div></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ScreenSaver',
  data () {
    return {
      hideScreenSaver: false,
      currentImage: (Math.floor(Math.random() * 4) + 1),
      vid: null
    }
  },
  props: ['paused'],
  watch: {
    paused () {
      if (this.paused) {
        this.pause()
      } else {
        this.unpause()
      }
    }
  },
  computed: {
    showText () {
      return this.currentImage > 2
    },
    backgroundImage () {
      return '/static/splash-images/' + this.currentImage + '.jpg'
    },
    splashVideo () {
      return `${process.env.BASE_URL}laika-splash-${this.currentImage}.mp4`
    }
  },
  mounted: function () {
    this.vid = this.$refs['ssvid']

    document.getElementById('screen-saver').style.height = window.innerHeight + "px"

    if (this.showText) {
      document.getElementById('screen-saver-text').style.height = window.innerHeight + "px"
    }

    setTimeout(() => { this.closeScreenSaver() }, 15000)

    let videoPromise = this.vid.play();
    if (videoPromise !== undefined) {
        videoPromise.catch(() => {
            // Auto-play was prevented
            // Show a UI element to let the user manually start playback
            this.videoEnded
        }).then(() => {
            // Auto-play started
        });
    }
    this.vid.addEventListener('ended', this.videoEnded, false)
  },
  methods: {
    videoEnded () {
      this.closeScreenSaver()
    },
    updateImage () {
      this.currentImage = (Math.floor(Math.random() * 5) + 1)
    },
    closeScreenSaver () {
      this.hideScreenSaver = true
    }
  }
}
</script>

<style>

  #spinner {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  #screen-saver {
    cursor: pointer;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 11000;
    background: black;
    background-size: cover;
    background-repeat: no-repeat;
    opacity: 1;
    transition: opacity 1.5s ease-out;

    video {
      position: fixed;
      top: 50%;
      left: 50%;
      min-width: 100%;
      min-height: 100%;
      width: auto;
      height: auto;
      z-index: 100;
      transform: translateX(-50%) translateY(-50%);
      background-size: cover;
      transition: 1s opacity;
    }

    @media only screen
    and (max-device-width: 667px)
    and (orientation: portrait) {
      video {
        height: 50vh;
      }
    }

    &.hide {
      pointer-events: none;
      opacity: 0;
    }

    #screen-saver-text {
      position: fixed;
      pointer-events: none;
      height: 100vh;
      z-index: 200;
      &>div {
        height: 20vh;

        &:first-child {
          padding-left: 1.1em;
        }

        &:nth-child(2) {
          padding-left: 25vw;
        }

        &:nth-child(3) {
          padding-left: 48vw;
        }

        &:nth-child(4) {
          padding-left: 75vw;
        }

        &:nth-child(5) {
          padding-left: 94vw;
        }
      }
    }

    @media screen and (max-device-width: 768px) {
      #screen-saver-text {
        &>div {
          height: 20vh;

          &:nth-child(2) {
          padding-left: 23vw;
        }

        &:nth-child(3) {
          padding-left: 46vw;
        }

        &:nth-child(4) {
          padding-left: 72vw;
        }

          &:nth-child(5) {
            padding-left: 90vw;
          }
        }
      }
    }
  }
</style>
